import { useQuery } from "@tanstack/react-query";
import { getMarketingEcomm } from "../services/ecommMarketingService";

export const useMarketingEcomm = (month = "2025-04", limit = 40) => {
  return useQuery({
    queryKey: ["ecomm-marketingDashboard", month, limit],
    queryFn: () => getMarketingEcomm(month, limit),
    staleTime: 1000 * 60 * 5, 
  });
};